import { t as e } from "./chunk-debounce-CrCUjCd1.js";
//#region src/entry/analytics.ts
var { Shopify: t } = window;
document.addEventListener("DOMContentLoaded", () => {
	a(), n(), o();
});
var n = () => {
	document.addEventListener("click", (e) => {
		let n = e.target;
		n && n.tagName === "A" && t.analytics.publish("link_click", {
			link_classes: n.className,
			link_domain: n.href ? new URL(n.href).hostname : "",
			link_id: n.id,
			link_url: n.href,
			outbound: n.target === "_blank"
		});
	});
}, r = [
	10,
	25,
	50,
	75
], i = e((() => {
	let e = document.body.scrollHeight - window.innerHeight;
	if (e <= 0) return;
	let n = Math.round(window.scrollY / e * 100);
	for (let e of r) n >= e && t.analytics.publish("scroll_depth", { percent_scrolled: e });
}).bind(void 0), 100), a = () => {
	window.addEventListener("scroll", i);
}, o = () => {
	document.addEventListener("visibilitychange", () => {
		document.visibilityState === "hidden" ? t.analytics.publish("inactive", {}) : document.visibilityState === "visible" && t.analytics.publish("active", {});
	});
};
//#endregion
